module.exports = " <div class=maps> <v-head></v-head> <div id=allmap style=\"width: 800px;height: 800px\"></div> </div> ";


//////////////////
// WEBPACK FOOTER
// ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/maps/maps.vue
// module id = 64
// module chunks = 1